/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import Help from '@material-ui/icons/Help';
import Create from '@material-ui/icons/Create';
import { Link } from 'react-router-dom';
import { Translate } from 'src/translations/i18n';
import TooltipComponent from '../Tooltip';

const iconStyle = {
  width: 15, height: 15, marginLeft: 8, color: 'grey'
};

function TooltipForField(props) {
  return (
    <>
      <TooltipComponent
      content={<Help style={iconStyle} />}
      tooltip={(
        <div style={{ zIndex: 500 }}>
          <Translate value={props.tooltipContent} />
        </div>
      )}
      placement={props.placement}
      minimalWidth="200px"
    />
      {props.linkEnabled
    && (
    <Link to={props.linkTo}>
      <Create style={iconStyle} />
    </Link>
    )}

    </>
  );
}

export default TooltipForField;

TooltipForField.propTypes = {
  tooltipContent: PropTypes.string,
  linkEnabled: PropTypes.bool,
  linkTo: PropTypes.string,
  placement: PropTypes.string
};

TooltipForField.defaultProps = {
  tooltipContent: '',
  linkEnabled: false,
  linkTo: '',
  placement: 'top'
};
